import Emotes from './Components/Emotes';
import Footer from './Components/Footer';
import './App.css';

function App() {
  return (
    <div className="App-header">
      <Emotes />
      <Footer />
    </div>
  );
}

export default App;
